module.exports = __webpack_public_path__ + "img/Countdown.11eda963.svg";